import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';

const redirectBackToLogin = () =>{
    this.props.history.push("/login")
};
const startTest = async (e) => {
    const target = e.target;

}

const useStyles = makeStyles({
    title: {
        fontWeight: 'bold',
        color: '#2b1c1c',
        marginBottom: 25,
        fontSize: '1.75rem',
    },
    note: {
        maxWidth: 300,
        fontWeight: 'bold',
    },
    list: {
        color: '#960c0c',
        fontWeight: 'bold',
        paddingLeft: '15px !important',
        marginBottom: 30,
        '& > li': {
            marginBottom: 20,
            fontSize: 12
        }
    },
    cancel: {
        padding: '8px 10px',
        border: '2px solid #FF2E2E',
        background: '#FFF',
        color: '#FF2E2E',
        transition: 'all .5s ease',
        '&:hover': {
            background: '#FF2E2E',
            color: '#FFF',
        },
    },
    start: {
        padding: '8px 10px',
        background: '#FF2E2E',
        color: '#FFF',
        border: '2px solid #FF2E2E',
        transition: 'all .5s ease',
        '&:hover': {
            background: '#960C0C',
            borderColor: '#960C0C',
        },
        '& > a': {
            color: 'inherit',
            '&:hover': {
                color: 'inherit',
            }
        }
    },
    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        width: 200
    },

});

function SimpleDialog(props) {
    const classes = useStyles();
    const {onClose, open} = props;


    return (
        <Dialog onClose={onClose} aria-labelledby="simple-dialog-title" open={true}>
            <div className="p-4 p-sm-5">
                <h2 id="simple-dialog-title" className={classes.title}>Start your MBTI test</h2>
                <div className={classes.note}>
                    <ul className={classes.list}>
                        <li>This test is not timed</li>
                        <li>You have only ONE ATTEMPT to take this test.</li>
                        <li>There are no right or wrong answers.</li>
                        <li>Select an option that most describes you.</li>
                    </ul>
                </div>
                <div className="error-message">
                    <p id={"errMessage"} className="text-danger"></p>
                </div>
                <div className={classes.buttons}>
                    <a href="https://apply.semicolon.africa/login">
                    <button onClick={redirectBackToLogin} className={classes.cancel}>Cancel</button>
                    </a>
                    <a href="/start_test">
                    <button className={classes.start} onClick={startTest}>Start Test</button>
                    </a>
                </div>
            </div>
        </Dialog>
    );
}


export default function TestModal(props) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };



    const enableButton = (target) => {

        target.style.background = "#FF2E2E";
        target.style.borderColor = "#FF2E2E";
        target.removeAttribute("disabled");
    }

    const handleError = (err, target) => {
        function displayError() {
            eMessage.textContent = ""
        }

        const eMessage = document.querySelector("#errMessage");
        if (err.response === undefined) {
            eMessage.textContent = "Check your network connection and try again";
            setTimeout(displayError, 4000);
            enableButton(target)

            // startTest(e);
        } else {

            switch (err.response.status) {
                case 401:
                case 403:
                    eMessage.textContent = "Session expired please re-login";
                    setTimeout(displayError, 10000);
                    this.props.history.push('/login')


                    break;
                case 400:
                    eMessage.textContent = "Already tested please re-login";
                    setTimeout(displayError, 10000);
                    handleClose()
                    props.userDashCompProps.history.push('/login')

                    break;
                default:
                    break;
            }
        }
    }


    function getTestText() {

    }


    return (
        <div>
            <p onClick={handleClickOpen} style={{
                // pointerEvents: (user.applicationStatus === "QUESTIONNAIRE") ? "initial" : "none"
            }} className="m-0">
                {getTestText()}
            </p>
            <SimpleDialog open={open} onClose={handleClose} startTest={startTest}/>

        </div>
    );
}

